import { PostStatus } from '../constants';
import { Type } from './action-types';
import { BlueskyAction, BlueskyState, blueskyStateFactory } from './types';

const defaultState = blueskyStateFactory();

export default function(
  state: BlueskyState = defaultState,
  action: BlueskyAction,
) {
  switch (action.type) {
    case Type.BLUESKY_USER_DATA_GET_SUCCESS: {
      const { username, profileImageUrl } = action.payload;

      return state
        .set('username', username)
        .set('profileImageUrl', profileImageUrl);
    }

    case Type.BLUESKY_USER_DATA_GET_AWAIT_REQUEST: {
      return state.set('isLoadingUser', true);
    }

    case Type.BLUESKY_USER_DATA_GET_AWAIT_SUCCESS:
    case Type.BLUESKY_USER_DATA_GET_AWAIT_FAILURE:
      return state.set('isLoadingUser', false);

    case Type.BLUESKY_USER_DATA_CLEAR:
      return blueskyStateFactory();

    case Type.BLUESKY_VIDEO_POST_REQUEST:
      return state.set('postStatus', PostStatus.IN_PROGRESS);

    case Type.BLUESKY_VIDEO_POST_SUCCESS: {
      const { socialShareId } = action.payload;

      return state.set('socialShareId', socialShareId);
    }

    case Type.BLUESKY_VIDEO_POST_FAILURE:
    case Type.BLUESKY_VIDEO_POST_AWAIT_FAILURE:
      return state.set('postStatus', PostStatus.FAILURE);

    case Type.BLUESKY_VIDEO_POST_AWAIT_SUCCESS:
      return state.set('postStatus', PostStatus.SUCCESS);

    case Type.BLUESKY_AUTHORIZE_SUCCESS: {
      return state.merge(action.payload);
    }

    default:
      return state;
  }
}
